import React from 'react';

interface StatItem {
    label: string;
    value: string | number;
}

interface StatsOverviewProps {
    stats: StatItem[];
}

const StatsOverview: React.FC<StatsOverviewProps> = ({ stats }) => {
    return (
        <div className="row g-4 mb-4">
            {stats.map((stat, index) => (
                <div key={index} className="col-12 col-lg-4 col-md-6">
                    <div
                        className="d-flex flex-column align-items-start justify-content-center p-4 shadow-sm border rounded-min"
                        style={{
                            backgroundColor: "#FFFFFF",
                            fontFamily: "Work Sans, sans-serif",
                            height: "100%"
                        }}
                    >
                        <div
                            style={{
                                color: "#5A5A5A",
                                fontSize: "18px",
                                fontWeight: "500",
                                marginBottom: "10px"
                            }}
                        >
                            {stat.label}
                        </div>
                        <div
                            style={{
                                fontSize: "32px",
                                fontWeight: "700",
                                color: "#1E1E1E"
                            }}
                        >
                            {stat.value}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StatsOverview;
